import { useEffect, useRef } from 'react';
import { MessageTypes } from '../constants';

/**
 * Used to send size updates to the parent window.
 *
 * Default type of message is `MessageTypes.UpdatedSize`, but it can be overridden if needed.
 */
const useIframeResize = (type: string = MessageTypes.UpdatedSize) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) {
      return;
    }

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { height } = entry.contentRect;
        const message = {
          type,
          height,
        };

        window.parent.postMessage(message, '*');
      }
    });

    resizeObserver.observe(containerRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [type]);

  return { containerRef };
};

export default useIframeResize;
